export const BUSINESS_CATEGORY_SEPARATOR = ' > ';

export function composeBusinessCategory(businessCategory: string, subCategory: string): string {
  return `${businessCategory.trim()}${BUSINESS_CATEGORY_SEPARATOR}${subCategory.trim()}`;
}

export function parseBusinessCategory(stored: string | null | undefined): {
  businessCategory: string;
  subCategory: string;
} {
  if (!stored?.trim()) {
    return { businessCategory: '', subCategory: '' };
  }

  const idx = stored.indexOf(BUSINESS_CATEGORY_SEPARATOR);
  if (idx === -1) {
    return { businessCategory: '', subCategory: stored.trim() };
  }

  return {
    businessCategory: stored.slice(0, idx).trim(),
    subCategory: stored.slice(idx + BUSINESS_CATEGORY_SEPARATOR.length).trim(),
  };
}

export function formatBusinessCategoryLabel(
  category?: string | null,
  subCategory?: string | null,
  selfDefinedCategory?: string | null
): string {
  const custom = selfDefinedCategory?.trim() ?? '';
  if (custom) return custom;

  const parent = category?.trim() ?? '';
  const sub = subCategory?.trim() ?? '';
  if (sub) return sub;
  return parent;
}
